<template>
    <section v-if="rss.inbound">
        <div
            v-if="rss.inbound.status == 1"
            class="iv2-rss theme-b__home-news-bg"
        >
            <div class="container">
                <div class="row clearfix">
                    <div class="column full">
                        <h3
                            class="iv2-rss__title theme__heading-text"
                            style="text-align: center;"
                        >
                            BLOG
                        </h3>
                    </div>
                </div>
                <div class="row clearfix">
                    <div
                        v-for="item in rss.inbound.items"
                        :key="item.key"
                        class="col-md-6 col-12"
                    >
                        <a
                            :href="item.url"
                            class="iv2-rss__items-link"
                            target="_blank"
                            rel="noopener"
                        >
                            <div
                                class="iv2-rss__items theme-b__home-rss__items column full"
                            >
                                <small>{{ item.created | moment }}</small>
                                <h4 class="iv2-rss__items-title">
                                    {{ item.title }}
                                </h4>
                                <p class="iv2-rss__items-summary">
                                    {{ item.body }}
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row clearfix">
                    <div class="column full">
                        <p style="text-align: right;">
                            <a
                                :href="rss.inbound.site_url"
                                target="_blank"
                                rel="noopener"
                                >{{ rss.inbound.site_title }}</a
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import moment from "moment";
export default {
    data() {
        return {
            rss: [],
        };
    },

    created() {
        this.axios.get("/json/rss.json").then((response) => {
            this.rss = response.data.rss;
        });
    },

    computed: {
        limitCount() {
            return this.items.news.list.slice(0, this.rss.limit);
        },
    },

    filters: {
        moment: function(created) {
            return moment(created).format("YYYY.MM.DD");
        },
    },
};
</script>

<style lang="scss">
.iv2-rss {
    padding-top: 5rem;
    margin-top: 160px;
    padding-bottom: 160px;
    margin-bottom: -160px;

    .iv2-rss__title {
        margin: 2rem 0;
    }

    .iv2-rss__items {
        margin: 1rem 0;
        padding: 0.5rem 1rem;
        height: 90%;

        .iv2-rss__items-title {
            margin: 0;
            font-weight: normal;
        }

        .iv2-rss__items-link {
            padding: 6px 18px;
            font-size: 11px;
            text-decoration: initial;
            word-break: keep-all;
        }
    }
}

@media (max-width: 1199px) {
    .iv2-rss {
        margin-top: 80px;
    }
}
</style>
